/**
 * Configuração do TanStack Query.
 *
 * As escolhas aqui vêm do perfil real do dado: as planilhas são atualizadas
 * algumas vezes por semana, não por segundo. Refetch agressivo custaria
 * recalcular séries em pandas para não mostrar nada de novo.
 */

import { QueryClient } from '@tanstack/react-query'

import { ErroApi } from './api'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: (tentativas, erro) => {
        // Repetir um 400 ("`serie` desconhecida") ou um 403 só atrasa a
        // mensagem que o operador precisa ler. Repetição é para falha de rede.
        if (erro instanceof ErroApi && erro.status < 500) return false
        return tentativas < 2
      },
    },
    mutations: {
      retry: false,
    },
  },
})

/**
 * Prefixos de chave.
 *
 * Centralizados porque invalidação errada é bug silencioso: criar um de-para
 * precisa invalidar as pendências, e uma chave escrita à mão em dois arquivos
 * diverge no dia em que um deles muda.
 */
export const chaves = {
  catalogo: ['catalogo'] as const,
  produtos: ['catalogo', 'produtos'] as const,
  clientes: ['catalogo', 'clientes'] as const,
  bases: ['catalogo', 'bases'] as const,
  pracas: ['catalogo', 'pracas'] as const,
  distribuidoras: ['catalogo', 'distribuidoras'] as const,

  tbContexto: ['terrabrasil', 'contexto'] as const,
  tbRegua: (filtros: unknown) => ['terrabrasil', 'regua', filtros] as const,
  tbReguaFavoritos: (filtros: unknown) => ['terrabrasil', 'regua-favoritos', filtros] as const,
  tbBalizador: (referencia: string) => ['terrabrasil', 'balizador', referencia] as const,

  uploads: ['ingestao', 'uploads'] as const,
  upload: (id: number) => ['ingestao', 'uploads', id] as const,
  resumoPendencias: (id: number) => ['ingestao', 'uploads', id, 'pendencias'] as const,
  pendencias: (filtros: unknown) => ['ingestao', 'pendencias', filtros] as const,
  deParas: (tipo: string, busca: string, pagina: number) =>
    ['ingestao', 'de-paras', tipo, busca, pagina] as const,

  usuarios: (busca: string, pagina: number) => ['usuarios', busca, pagina] as const,
}
